import * as React from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { performanceLog } from 'modules/core/lib/datadogLogger'

interface Props {
  intent: string
}

const useTelemetry = (intent: string) => {
  const { access, company, email } = useCurrentSession()

  React.useEffect(() => {
    if (typeof window.performance.mark !== 'function') return () => {}

    const markStart = `${intent}_start`
    const markEnd = `${intent}_end`
    window.performance.mark(markStart)

    return () => {
      window.performance.mark(markEnd)
      window.performance.measure(intent, markStart, markEnd)

      performanceLog(
        {
          name: `Loading state ${intent}`,
          start_time_name: markStart,
          measure_name: intent,
        },
        {
          companyName: company.name,
          companyId: company.id,
          companySize: company.size,
          userEmail: email,
          userId: access.id,
        }
      )
      window.performance.clearMarks(markStart)
      window.performance.clearMarks(markEnd)
      window.performance.clearMeasures(intent)
    }
  }, [intent])
}

const Telemetry = (props: React.PropsWithChildren<Props>) => {
  const { intent, children } = props
  useTelemetry(intent)

  return <>{children}</>
}

export default Telemetry
